import React, { useState } from "react";
import UI from "@mile-meeting/mile-ui";
import styled from "@emotion/styled";

interface RoomNameFieldProps {
  name: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const RoomNameField: React.FC<RoomNameFieldProps> = ({ name, onChange, disabled = false }) => {
  const [value, setValue] = useState(name);

  const handleChange = (value: string) => {
    if (value.length > 50) return;
    onChange(value);
    setValue(value);
  };

  return (
    <Container>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        회의실 이름 <RequiredAsterisk>*</RequiredAsterisk>
      </UI.Typography>
      <UI.Input
        disabled={disabled}
        placeholder="회의실 이름"
        showMaxLength
        maxLength={50}
        onChange={handleChange}
        value={value}
      />
    </Container>
  );
};

export default React.memo(RoomNameField);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RequiredAsterisk = styled.span`
  color: var(--alias-color-primary-normal);
`;
